import axios from "axios";
import {
  STATISTIC_PATIENT_STATS_REQUEST,
  STATISTIC_PATIENT_STATS_SUCCESS,
  STATISTIC_PATIENT_STATS_FAIL,
  STATISTIC_TREATMENT_PLAN_STATS_REQUEST,
  STATISTIC_TREATMENT_PLAN_STATS_SUCCESS,
  STATISTIC_TREATMENT_PLAN_STATS_FAIL,
  STATISTIC_TOP_SERVICES_REQUEST,
  STATISTIC_TOP_SERVICES_SUCCESS,
  STATISTIC_TOP_SERVICES_FAIL,
  STATISTIC_TOP_SERVICE_GROUPS_REQUEST,
  STATISTIC_TOP_SERVICE_GROUPS_SUCCESS,
  STATISTIC_TOP_SERVICE_GROUPS_FAIL,
  STATISTIC_TOP_EMPLOYEES_REQUEST,
  STATISTIC_TOP_EMPLOYEES_SUCCESS,
  STATISTIC_TOP_EMPLOYEES_FAIL,
  STATISTIC_COORDINATORS_REQUEST,
  STATISTIC_COORDINATORS_SUCCESS,
  STATISTIC_COORDINATORS_FAIL,
  STATISTIC_DOCTOR_TOP_SERVICE_REQUEST,
  STATISTIC_DOCTOR_TOP_SERVICE_SUCCESS,
  STATISTIC_DOCTOR_TOP_SERVICE_FAIL,
  STATISTIC_TREATMENT_PLAN_EMPLOYEE_STATS_REQUEST,
  STATISTIC_TREATMENT_PLAN_EMPLOYEE_STATS_SUCCESS,
  STATISTIC_TREATMENT_PLAN_EMPLOYEE_STATS_FAIL,
  STATISTIC_COORDINATOR_USER_REQUEST,
  STATISTIC_COORDINATOR_USER_SUCCESS,
  STATISTIC_COORDINATOR_USER_FAIL,
  STATISTIC_EMPLOYEE_DOCTOR_STATS_REQUEST,
  STATISTIC_EMPLOYEE_DOCTOR_STATS_SUCCESS,
  STATISTIC_EMPLOYEE_DOCTOR_STATS_FAIL,
  STATISTIC_MONTHLY_TREATMENT_PLAN_STATS_REQUEST,
  STATISTIC_MONTHLY_TREATMENT_PLAN_STATS_SUCCESS,
  STATISTIC_MONTHLY_TREATMENT_PLAN_STATS_FAIL,
  STATISTIC_CASE_ACCEPTANCE_STATS_REQUEST,
  STATISTIC_CASE_ACCEPTANCE_STATS_SUCCESS,
  STATISTIC_CASE_ACCEPTANCE_STATS_FAIL,
  STATISTIC_MONTHLY_TREATMENT_PLAN_STACKED_STATS_REQUEST,
  STATISTIC_MONTHLY_TREATMENT_PLAN_STACKED_STATS_SUCCESS,
  STATISTIC_MONTHLY_TREATMENT_PLAN_STACKED_STATS_FAIL,
  STATISTIC_PATIENT_STATS_NEW_REQUEST,
  STATISTIC_PATIENT_STATS_NEW_SUCCESS,
  STATISTIC_PATIENT_STATS_NEW_FAIL,
} from "../constants/statisticConstants";

import { logout } from "./userActions";

export const getPatientStatistics = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: STATISTIC_PATIENT_STATS_REQUEST,
    });

    const {
      authLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`/api/statistics/patients`, config);

    dispatch({
      type: STATISTIC_PATIENT_STATS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: STATISTIC_PATIENT_STATS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    if (
      error.response &&
      error.response.data.message === "Not authorized, token failed"
    ) {
      dispatch(logout());
    }
  }
};

export const getTreatmentPlanStatistics =
  (slug) => async (dispatch, getState) => {
    try {
      dispatch({
        type: STATISTIC_TREATMENT_PLAN_STATS_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(
        `/api/${slug}/statistics/treatment-plans`,
        config
      );

      dispatch({
        type: STATISTIC_TREATMENT_PLAN_STATS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: STATISTIC_TREATMENT_PLAN_STATS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      if (
        error.response &&
        error.response.data.message === "Not authorized, token failed"
      ) {
        dispatch(logout());
      }
    }
  };

export const getTopServices = (slug) => async (dispatch, getState) => {
  try {
    dispatch({
      type: STATISTIC_TOP_SERVICES_REQUEST,
    });

    const {
      authLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    // Get top services
    const { data } = await axios.get(
      `/api/${slug}/statistics/top-services`,
      config
    );

    dispatch({
      type: STATISTIC_TOP_SERVICES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: STATISTIC_TOP_SERVICES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    if (
      error.response &&
      error.response.data.message === "Not authorized, token failed"
    ) {
      dispatch(logout());
    }
  }
};

export const getTopServiceGroups = (slug) => async (dispatch, getState) => {
  try {
    dispatch({
      type: STATISTIC_TOP_SERVICE_GROUPS_REQUEST,
    });

    const {
      authLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    // Get top service groups
    const { data } = await axios.get(
      `/api/${slug}/statistics/top-service-groups`,
      config
    );

    dispatch({
      type: STATISTIC_TOP_SERVICE_GROUPS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: STATISTIC_TOP_SERVICE_GROUPS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    if (
      error.response &&
      error.response.data.message === "Not authorized, token failed"
    ) {
      dispatch(logout());
    }
  }
};

export const getTopEmployees = (slug) => async (dispatch, getState) => {
  try {
    dispatch({
      type: STATISTIC_TOP_EMPLOYEES_REQUEST,
    });

    const {
      authLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    // Get top employees
    const { data } = await axios.get(
      `/api/${slug}/statistics/top-employees`,
      config
    );

    dispatch({
      type: STATISTIC_TOP_EMPLOYEES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: STATISTIC_TOP_EMPLOYEES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    if (
      error.response &&
      error.response.data.message === "Not authorized, token failed"
    ) {
      dispatch(logout());
    }
  }
};

export const getCoordinatorStatistics = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: STATISTIC_COORDINATORS_REQUEST,
    });

    const {
      authLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    // Get top employees
    const { data } = await axios.get(`/api/statistics/coordinators`, config);

    dispatch({
      type: STATISTIC_COORDINATORS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: STATISTIC_COORDINATORS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    if (
      error.response &&
      error.response.data.message === "Not authorized, token failed"
    ) {
      dispatch(logout());
    }
  }
};

export const getTopServicesDoctor = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: STATISTIC_DOCTOR_TOP_SERVICE_REQUEST,
    });

    const {
      authLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    // Get top services
    const { data } = await axios.get(
      `/api/statistics/top-user-services`,
      config
    );

    dispatch({
      type: STATISTIC_DOCTOR_TOP_SERVICE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: STATISTIC_DOCTOR_TOP_SERVICE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getTreatmentPlanStatisticsEmployee =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: STATISTIC_TREATMENT_PLAN_EMPLOYEE_STATS_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      // Get top services
      const { data } = await axios.get(
        `/api/statistics/employee-treatment-plans`,
        config
      );

      dispatch({
        type: STATISTIC_TREATMENT_PLAN_EMPLOYEE_STATS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: STATISTIC_TREATMENT_PLAN_EMPLOYEE_STATS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getCoordinatorUserStatistics =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: STATISTIC_COORDINATOR_USER_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      // Get top services
      const { data } = await axios.get(
        `/api/statistics/coordinators-user`,
        config
      );

      dispatch({
        type: STATISTIC_COORDINATOR_USER_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: STATISTIC_COORDINATOR_USER_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getEmployeeDoctorStatistics =
  (employeeId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: STATISTIC_EMPLOYEE_DOCTOR_STATS_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      // Get top services
      const { data } = await axios.get(
        `/api/statistics/employees/doctor/${employeeId}`,
        config
      );

      dispatch({
        type: STATISTIC_EMPLOYEE_DOCTOR_STATS_SUCCESS,
        payload: data,
      });

      // console.log("data", data);
    } catch (error) {
      dispatch({
        type: STATISTIC_EMPLOYEE_DOCTOR_STATS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Action to get monthly treatment plan statistics, optionally filtered by year
export const getMonthlyTreatmentPlanStatistics =
  (year, slug) => async (dispatch, getState) => {
    try {
      dispatch({
        type: STATISTIC_MONTHLY_TREATMENT_PLAN_STATS_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      // Pass the year as a query parameter if provided
      const { data } = await axios.get(
        `/api/${slug}/statistics/monthly-treatment-plans?year=${year || ""}`,
        config
      );

      // Log the API request to ensure it's hitting the right endpoint
      // console.log(`/api/statistics/monthly-treatment-plans?year=${year || ""}`);

      // Log the data received from the API to ensure it's being fetched correctly
      // console.log("Data received from API:", data);

      dispatch({
        type: STATISTIC_MONTHLY_TREATMENT_PLAN_STATS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: STATISTIC_MONTHLY_TREATMENT_PLAN_STATS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });

      if (
        error.response &&
        error.response.data.message === "Not authorized, token failed"
      ) {
        dispatch(logout());
      }
    }
  };

export const getCaseAcceptanceStatistics =
  (slug) => async (dispatch, getState) => {
    try {
      dispatch({
        type: STATISTIC_CASE_ACCEPTANCE_STATS_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(
        `/api/${slug}/statistics/case-acceptance`,
        config
      );

      dispatch({
        type: STATISTIC_CASE_ACCEPTANCE_STATS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: STATISTIC_CASE_ACCEPTANCE_STATS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
      if (
        error.response &&
        error.response.data.message === "Not authorized, token failed"
      ) {
        dispatch(logout());
      }
    }
  };

// Action to get monthly treatment plan statistics (stacked by status), optionally filtered by year
export const getMonthlyTreatmentPlanStatisticsStacked =
  (year, slug) => async (dispatch, getState) => {
    try {
      dispatch({
        type: STATISTIC_MONTHLY_TREATMENT_PLAN_STACKED_STATS_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      // Call the correct endpoint that returns the stacked treatment plan data
      const { data } = await axios.get(
        `/api/${slug}/statistics/monthly-treatment-plans-stacked?year=${
          year || ""
        }`,
        config
      );

      dispatch({
        type: STATISTIC_MONTHLY_TREATMENT_PLAN_STACKED_STATS_SUCCESS,
        payload: data, // `data` contains `monthlyStats` with statuses
      });
    } catch (error) {
      dispatch({
        type: STATISTIC_MONTHLY_TREATMENT_PLAN_STACKED_STATS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });

      if (
        error.response &&
        error.response.data.message === "Not authorized, token failed"
      ) {
        dispatch(logout());
      }
    }
  };

export const getPatientStatisticsNewAction =
  (slug) => async (dispatch, getState) => {
    try {
      dispatch({
        type: STATISTIC_PATIENT_STATS_NEW_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(
        `/api/${slug}/statistics/patients-new`,
        config
      );

      dispatch({
        type: STATISTIC_PATIENT_STATS_NEW_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: STATISTIC_PATIENT_STATS_NEW_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
